import { useState } from "react";
export const useHybridState = ({ defaultValue, onChange, value, }) => {
    const [_value, _setValue] = useState(value ?? defaultValue);
    const state = [value ?? _value, onChange || _setValue];
    return state;
};
